var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLivoritCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 499,
    height: 545,
    viewBox: "0 0 499 545",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.422 440.58L1.00902 323.345V183.11C0.777299 166.768 5.01551 150.669 13.2736 136.522C21.5316 122.375 33.5012 110.709 47.9113 102.762L203.764 13.7437C217.948 5.40205 234.137 1 250.63 1C267.123 1 283.311 5.40205 297.495 13.7437L303.979 17.402L111.436 127.431C101.452 133.175 94.1714 142.606 91.1874 153.658C88.2034 164.711 89.7595 176.485 95.515 186.403L230.255 417.119C232.141 420.396 232.888 424.197 232.38 427.936C231.871 431.676 230.136 435.145 227.441 437.811C224.746 440.476 221.242 442.188 217.468 442.685C213.694 443.181 209.86 442.433 206.557 440.556L206.422 440.58Z",
    stroke: "url(#paint0_linear_3344_1004)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.759 460.582L296.498 530.797C282.358 539.179 266.207 543.603 249.752 543.603C233.297 543.603 217.146 539.179 203.006 530.797L47.7346 441.746C33.3975 433.797 21.4856 422.135 13.2597 407.995C5.03392 393.855 0.800366 377.763 1.00723 361.423V354.014L192.795 464.073C202.796 469.79 214.659 471.342 225.803 468.391C236.947 465.439 246.469 458.223 252.296 448.314L386.52 217.159C388.424 213.886 391.356 211.328 394.864 209.88C398.373 208.432 402.263 208.174 405.933 209.146C409.603 210.118 412.85 212.266 415.173 215.259C417.495 218.251 418.764 221.922 418.783 225.704L418.759 460.582Z",
    stroke: "url(#paint1_linear_3344_1004)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.047 149.764L125.548 148.897C125.156 149.123 124.964 149.584 125.081 150.022C125.198 150.46 125.594 150.764 126.047 150.764V149.764ZM329.331 32.8672L329.828 31.9999L329.33 31.7139L328.832 32.0003L329.331 32.8672ZM450.882 102.629L450.384 103.496L450.396 103.503L450.882 102.629ZM497.325 182.694L496.325 182.681V182.694H497.325ZM497.325 360.033H496.325L496.325 360.046L497.325 360.033ZM450.967 440.05L450.481 439.176L450.473 439.18L450.967 440.05ZM444.55 443.695H443.55V445.413L445.044 444.565L444.55 443.695ZM444.55 224.702L445.55 224.702L445.55 224.699L444.55 224.702ZM401.382 181.662L401.384 180.662H401.382V181.662ZM134.705 181.662L134.705 180.662L134.702 180.662L134.705 181.662ZM126.12 149.764L126.618 150.632L129.874 148.764H126.12V149.764ZM126.545 150.631L329.829 33.7341L328.832 32.0003L125.548 148.897L126.545 150.631ZM328.833 33.7345L450.384 103.496L451.38 101.761L329.828 31.9999L328.833 33.7345ZM450.396 103.503C464.496 111.341 476.209 122.838 484.294 136.777L486.024 135.774C477.758 121.523 465.783 109.768 451.368 101.755L450.396 103.503ZM484.294 136.777C492.38 150.716 496.537 166.577 496.325 182.681L498.325 182.708C498.541 166.242 494.291 150.025 486.024 135.774L484.294 136.777ZM496.325 182.694V360.033H498.325V182.694H496.325ZM496.325 360.046C496.545 376.135 492.401 391.984 484.33 405.914L486.061 406.917C494.312 392.674 498.55 376.469 498.325 360.019L496.325 360.046ZM484.33 405.914C476.26 419.845 464.564 431.338 450.481 439.176L451.453 440.924C465.851 432.91 477.809 421.16 486.061 406.917L484.33 405.914ZM450.473 439.18L444.056 442.826L445.044 444.565L451.461 440.919L450.473 439.18ZM445.55 443.695V224.702H443.55V443.695H445.55ZM445.55 224.699C445.52 213.022 440.856 201.832 432.578 193.579L431.166 194.995C439.069 202.875 443.522 213.557 443.55 224.705L445.55 224.699ZM432.578 193.579C424.301 185.326 413.084 180.681 401.384 180.662L401.38 182.662C412.553 182.68 423.263 187.115 431.166 194.995L432.578 193.579ZM401.382 180.662H134.705V182.662H401.382V180.662ZM134.702 180.662C131.145 180.673 127.685 179.51 124.861 177.355L123.648 178.945C126.823 181.368 130.712 182.674 134.708 182.662L134.702 180.662ZM124.861 177.355C122.036 175.2 120.004 172.174 119.082 168.748L117.151 169.268C118.188 173.121 120.472 176.523 123.648 178.945L124.861 177.355ZM119.082 168.748C118.16 165.322 118.399 161.688 119.762 158.412L117.915 157.644C116.383 161.328 116.114 165.415 117.151 169.268L119.082 168.748ZM119.762 158.412C121.124 155.135 123.535 152.4 126.618 150.632L125.623 148.897C122.157 150.884 119.447 153.959 117.915 157.644L119.762 158.412ZM126.12 148.764H126.047V150.764H126.12V148.764Z",
    fill: "url(#paint2_linear_3344_1004)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3344_1004",
    x1: 152.49,
    y1: 1,
    x2: 152.49,
    y2: 442.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272582",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#54529D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882336,
    stopColor: "#5856A0",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3344_1004",
    x1: 419,
    y1: 376,
    x2: -9.21473,
    y2: 323.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30419A",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3B4784",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#30419A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5AEDC",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3344_1004",
    x1: 242.5,
    y1: 63.5,
    x2: 453.5,
    y2: 454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30419A",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "#30419A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5AEDC",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivoritCube);
export default __webpack_public_path__ + "static/media/livorit-cube.8bb8149940dbf0a4095d4af528c8f26b.svg";
export { ForwardRef as ReactComponent };